export function tryParseJwtClaims(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

export function isJwtExpired(token: string, leewaySeconds = 30): boolean {
  const claims = tryParseJwtClaims(token);
  if (!claims || typeof claims.exp !== 'number') return true;
  const expiresAt = (claims.exp as number) * 1000;
  return Date.now() > expiresAt - leewaySeconds * 1000;
}

export function getJwtExpiry(token: string): Date | null {
  const claims = tryParseJwtClaims(token);
  if (!claims || typeof claims.exp !== 'number') return null;
  return new Date((claims.exp as number) * 1000);
}

export function getJwtClaim<T = unknown>(token: string, claim: string): T | null {
  const claims = tryParseJwtClaims(token);
  if (!claims) return null;
  return (claims[claim] ?? null) as T | null;
}
